// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"so9V6gu2","ButtonSkeleton":"lFk9c0vQ","IconPlaceholder":"WVpg4xC2","NativeInput":"XmJx2Mor"};